import { render, staticRenderFns } from "./TonnageSpeed.vue?vue&type=template&id=327e38b8&scoped=true&"
import script from "./TonnageSpeed.vue?vue&type=script&lang=js&"
export * from "./TonnageSpeed.vue?vue&type=script&lang=js&"
import style0 from "./TonnageSpeed.vue?vue&type=style&index=0&id=327e38b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e38b8",
  null
  
)

export default component.exports